/**
 * Normalizes text for comparison by handling Unicode variants.
 * Handles cases like regular space vs non-breaking space, different dashes, quotes, etc.
 */
export function normalizeTextForComparison(text: string): string {
  return (
    text
      // Unicode normalization (NFC form)
      .normalize("NFC")
      // Replace various space characters with regular space
      .replace(/[\u00A0\u1680\u2000-\u200B\u202F\u205F\u3000\uFEFF]/g, " ")
      // Replace various dashes with regular hyphen
      .replace(/[\u2013\u2014\u2015]/g, "-")
      // Replace various quotes with regular quotes
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201C\u201D]/g, '"')
      // Trim whitespace
      .trim()
  );
}
